"use strict";
// Fetches images marked data-flix-defer (see snippets/responsive-image) only
// when they come near the screen.
//
// On a long grid the browser's own loading="lazy" starts downloads several
// screens ahead, and on a slow phone those downloads share the connection
// with the first, visible image — which then arrives seconds later. Here
// the margin is small, so the visible image gets the connection first.
(function () {
  function show(img) {
    if (!img.dataset.flixSrc) return;
    if (img.dataset.flixSrcset) img.srcset = img.dataset.flixSrcset;
    img.src = img.dataset.flixSrc;
    img.removeAttribute("data-flix-src");
    img.removeAttribute("data-flix-srcset");
    img.removeAttribute("data-flix-defer");
  }

  var io =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              io.unobserve(entry.target);
              show(entry.target);
            });
          },
          { rootMargin: "400px 0px" }
        )
      : null;

  function scan(scope) {
    scope.querySelectorAll("img[data-flix-defer]").forEach(function (img) {
      if (io) io.observe(img);
      else show(img);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan(document);
    });
  } else {
    scan(document);
  }
  // The theme editor re-renders one section at a time.
  document.addEventListener("shopify:section:load", function (event) {
    scan(event.target);
  });
})();
